import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { TabViewComponent, TabItem } from '../components/tab-view/tab-view.component';
import { findPaymentTabByLabel, findPaymentTabByRoute, PaymentsTabs } from './payment.data';

@Component({
  selector: 'app-payments',
  standalone: true,
  imports: [CommonModule, RouterModule, TabViewComponent],
  templateUrl: './payments.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './payments.component.scss',
})
export class PaymentsComponent implements OnInit, OnDestroy {
  activeTab = PaymentsTabs[0].label;
  paymentsTabs: TabItem[] = PaymentsTabs.map(tab => ({ name: tab.label }));

  private readonly subscription = new Subscription();

  constructor(private readonly router: Router) {}

  ngOnInit(): void {
    this.updateActiveTab();
    this.subscription.add(
      this.router.events
        .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe(() => this.updateActiveTab())
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onTabChange(tabName: string): void {
    const match = findPaymentTabByLabel(tabName);
    if (match) {
      this.activeTab = tabName;
      this.router.navigate(['/payments', match.route]);
    }
  }

  private updateActiveTab(): void {
    const segments = this.router.parseUrl(this.router.url).root.children['primary']?.segments ?? [];
    const last = segments[segments.length - 1]?.path ?? '';
    const match = findPaymentTabByRoute(last);
    if (match) {
      this.activeTab = match.label;
    }
  }
}
